export default __webpack_public_path__ + "static/media/Portfolio.5c5f7d87.pdf";